var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSovoro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 24,
    viewBox: "0 0 102 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_790_1961)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95 23.81H10.05L10.06 23.8C13.13 23.8 15.63 21.3 15.63 18.22C15.63 16.47 14.8 14.81 13.4 13.76L4.46 7.06C4 6.72 3.72 6.16 3.72 5.57C3.72 4.55 4.55 3.72 5.57 3.72H9.67C10.7 3.72 11.53 4.55 11.53 5.58V7.44H15.25V5.58C15.25 2.5 12.75 0 9.67 0H5.57C2.5 0 0 2.5 0 5.58C0 7.33 0.83 9 2.23 10.04L11.16 16.75C11.62 17.09 11.9 17.65 11.9 18.24C11.9 19.26 11.07 20.09 10.05 20.09H5.95C4.92 20.09 4.09 19.26 4.09 18.23V16.37H0.37V18.23C0.37 21.31 2.87 23.81 5.95 23.81ZM18 16.37C18 20.47 21.34 23.81 25.44 23.81C29.54 23.81 32.88 20.47 32.88 16.37V7.44C32.88 3.34 29.54 0 25.44 0C21.34 0 18 3.34 18 7.44V16.37ZM21.72 7.44C21.72 5.39 23.39 3.72 25.44 3.72C27.49 3.72 29.16 5.39 29.16 7.44V16.37C29.16 18.42 27.49 20.09 25.44 20.09C23.39 20.09 21.72 18.42 21.72 16.37V7.44ZM59.8599 23.81C55.7599 23.81 52.4199 20.47 52.4199 16.37V7.44C52.4199 3.34 55.7599 0 59.8599 0C63.9599 0 67.2999 3.34 67.2999 7.44V16.37C67.2999 20.47 63.9599 23.81 59.8599 23.81ZM59.8599 3.72C57.8099 3.72 56.1399 5.39 56.1399 7.44V16.37C56.1399 18.42 57.8099 20.09 59.8599 20.09C61.9099 20.09 63.5799 18.42 63.5799 16.37V7.44C63.5799 5.39 61.9099 3.72 59.8599 3.72ZM87.1201 16.37C87.1201 20.47 90.4601 23.81 94.5601 23.81C98.6601 23.81 102 20.47 102 16.37V7.44C102 3.34 98.6601 0 94.5601 0C90.4601 0 87.1201 3.34 87.1201 7.44V16.37ZM90.8401 7.44C90.8401 5.39 92.5101 3.72 94.5601 3.72C96.6101 3.72 98.2801 5.39 98.2801 7.44V16.37C98.2801 18.42 96.6101 20.09 94.5601 20.09C92.5101 20.09 90.8401 18.42 90.8401 16.37V7.44ZM82.12 13.02C83.67 11.66 84.65 9.66 84.65 7.43C84.65 3.33 81.32 0 77.22 0H75.35C72.27 0 69.77 2.5 69.77 5.58V23.81H73.49V14.88H77.22C79.27 14.88 80.93 16.55 80.93 18.59V23.81H84.65V18.59C84.65 16.37 83.67 14.38 82.12 13.02ZM73.49 11.16V5.58C73.49 4.55 74.32 3.72 75.35 3.72H77.22C79.27 3.72 80.93 5.39 80.93 7.45C80.93 9.51 79.26 11.16 77.22 11.16H73.49ZM42.8399 19.81L46.1399 0H46.1499H49.9199L46.5099 20.42C46.1799 22.38 44.4999 23.81 42.5099 23.81C40.5199 23.81 38.8399 22.38 38.5099 20.42L35.1099 0H38.8799L42.1799 19.81C42.2099 19.97 42.3499 20.09 42.5099 20.09C42.6699 20.09 42.8099 19.97 42.8399 19.81Z",
    fill: "url(#paint0_linear_790_1961)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_790_1961",
    x1: 65.2326,
    y1: -23.7981,
    x2: 65.2326,
    y2: 83.2934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8000FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_790_1961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSovoro);
export default __webpack_public_path__ + "static/media/logo-sovoro.3ce0fae68969549ec605297240005923.svg";
export { ForwardRef as ReactComponent };